/**
 * @namespace source.trash
 */
/**
 * @typedef Trash
 * @type Object
 */
import { toError } from './parsers/error';
function mapTrashParams(items, folders, settings) {
  items = items || [];
  folders = folders || [];
  const postData = {
    trash_files_id_list: items.map(item => item.id),
    trash_folders_id_list: folders.map(folder => folder.id)
  };
  if (settings.namespace) {
    postData.ns = settings.namespace;
  }
  return postData;
}
export function initTrash(settings, http) {
  const mapResponse = response => ({
    ...response,
    data: {
      opId: response.data.op_id
    },
    paging: {
      size: null,
      cursor: null
    }
  });

  /**
   * @summary Remove all items in trash
   * @memberof source.trash
   * @param items Array
   * @param folders Array
   * @returns {Promise}
   * @reject {Error}
   */
  function remove(items, folders) {
    const url = `${settings.apiUrl}/site/media/trash/delete`;
    const data = mapTrashParams(items, folders, settings);
    return http.post(url, data).then(mapResponse).catch(toError);
  }

  /**
   * @summary Restore all items in trash
   * @memberof source.trash
   * @param items Array
   * @param folders Array
   * @returns {Promise}
   * @reject {Error}
   */
  function restore(items, folders) {
    const url = `${settings.apiUrl}/site/media/trash/restore`;
    const data = mapTrashParams(items, folders, settings);
    return http.post(url, data).then(mapResponse).catch(toError);
  }

  /**
   * Empty trash
   * @param options
   * @returns {Promise}
   */
  function empty(options) {
    options = options || {};
    const url = `${settings.apiUrl}/site/media/trash/empty`;
    const payload = options.mediaType ? {
      media_type: options.mediaType
    } : {};
    const postOptions = {
      headers: options.headers || {}
    };
    if (settings.namespace) {
      payload.ns = settings.namespace;
    }
    return http.post(url, payload, null, postOptions).then(mapResponse).catch(toError);
  }
  return {
    remove,
    restore,
    empty
  };
}